// TODO: hack date validation isn't sophisticated enough to support arbitrary dates
// This is a temporary fix for the birthday question

import { ValidationsDate } from '@/api/generated-catch-backend/model';

export const QUESTION_SLUG_BIRTHDAY = 'question_birthday';

export const HACK_defaultBirthday = () => {
  const today = new Date();
  const thirtyYearsAgo = new Date(today.getFullYear() - 30, today.getMonth(), today.getDate());
  return thirtyYearsAgo;
};

export const HACK_birthdayValidation = (): ValidationsDate => {
  const today = new Date();
  const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  const oneHundredYearsAgo = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
  return {
    minDate: oneHundredYearsAgo.toISOString().split('T')[0], // 100 years ago
    maxDate: eighteenYearsAgo.toISOString().split('T')[0], // 18 years ago
  };
};
